module.exports = __webpack_public_path__ + "static/justlooking-3425f37c948b7c8da9657714723e8e05.png";